

import { EventEmitter } from '@billjs/event-emitter';

export class Menu {

	private trigger: HTMLButtonElement;
	private closeTrigger: HTMLButtonElement;
	private subTriggers: NodeListOf<HTMLButtonElement>;
	private nav: HTMLElement;
	private emitter: any;

	constructor() {
		this.emitter     	= new EventEmitter();
		this.trigger 		= document.querySelector('.menu-btn');
		this.closeTrigger   = document.querySelector('.close-btn');
		this.nav = document.querySelector('.main-menu-nav');
		this.subTriggers 	= document.querySelectorAll('.menu-item-has-children .toggler');

		if ( this.trigger ) {

			this.trigger.addEventListener( 'click', () => {
				if ( this.trigger.classList.contains( 'active' ) ) {
					this.closeMenu();
					this.emitter.fire('menu_close');
				} else {
					this.openMenu();
					this.emitter.fire('menu_open');
				}
			});

			this.closeTrigger.addEventListener('click', () => {
				this.closeMenu();
			});

			this.subTriggers.forEach( (subTrigger: HTMLButtonElement ) => {
				subTrigger.addEventListener('click', () => {
					if ( subTrigger.classList.contains('active') ) {
						this.closeSubmenu( subTrigger );
					} else {
						this.openSubmenu( subTrigger );
					}
				});
			});

			window.addEventListener('mouseup', (event) => {
				let contains = this.nav.contains(<HTMLElement>event.target);
				if (
					<HTMLElement>event.target != this.nav &&
					! contains
				) {
					this.closeMenu();
				}
			});
		}
	}

	openMenu() {
		document.body.classList.add('menu-open');
		this.trigger.classList.add('active');

		if ( this.nav ) {
			this.nav.classList.add('slide_in');
		}
	}


	closeMenu( ev?: MouseEvent ) {
		document.body.classList.remove('menu-open');
		this.trigger.classList.remove('active');

		if ( this.nav ) {
			this.nav.classList.remove('slide_in');
		}
	}

	openSubmenu( submenuTrigger: HTMLButtonElement) {
		submenuTrigger.closest('.menu-item').classList.add('active');
		submenuTrigger.classList.add('active');
	}

	closeSubmenu( submenuTrigger: HTMLButtonElement) {
		submenuTrigger.closest('.menu-item').classList.remove('active');
		submenuTrigger.classList.remove('active');
	}
	
}


